import { createOfferMetaSchema, schema } from '@funtech-int/yango-shared';

import { useMainSectionFallbackBackground } from './useMainSectionFallbackBackground';

export const useMultiOfferPaywallMetaSchema = () => {
    const background = useMainSectionFallbackBackground();

    return createOfferMetaSchema({
        paywallTitle: schema.string.optional(),
        plusLogo: schema.string.optional(),
        desktopBackgroundUrl: schema.string.optional(background),
        paymentIcons: schema.indexed('pms', schema.string).optional([]),
    });
};
